import { SVGProps } from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 12" {...props}>
        <path d="M12.2 6.857H7.057V12H5.343V6.857H.2V5.143h5.143V0h1.714v5.143H12.2v1.714Z" />
    </svg>
);
export default SvgPlus;
